module.exports = __webpack_public_path__ + "img/banner2.f08344e1.png";